import React from 'react';
import { User, DollarSign, Eye, CheckCircle, XCircle } from 'lucide-react';
import styles from './AnteProyectoCard.module.scss';
import StatusBadge from '../Shared/StatusBadge.tsx';
import { AnteProyectoValidation } from '../../../../types/backoffice.ts';

interface AnteProyectoCardProps {
  proyecto: AnteProyectoValidation;
  onViewDetails: (proyecto: AnteProyectoValidation) => void;
  onValidate: (id: string, isApproved: boolean, reason?: string, adminNote?: string) => void;
  validationLoading: boolean;
}

const AnteProyectoCard: React.FC<AnteProyectoCardProps> = ({
  proyecto,
  onViewDetails,
  onValidate,
  validationLoading
}) => {
  const firstImage = proyecto.files?.find(f => !f.external_url && f.url.match(/\.(jpg|jpeg|png|gif|webp)$/i))?.url;
  const userName = proyecto.user?.type === 'COMPANY' 
    ? proyecto.user.razon_social 
    : proyecto.user ? `${proyecto.user.name} ${proyecto.user.last_name || ''}`.trim() : 'Usuario no disponible';

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        {firstImage ? (
          <img src={firstImage} alt={proyecto.name} className={styles.image} />
        ) : (
          <div className={styles.noImage}>
            <Eye size={40} />
          </div>
        )}
        <div className={styles.statusBadge}>
          <StatusBadge status={proyecto.state} type="project" />
        </div>
      </div>

      <div className={styles.content}>
        <h3 className={styles.title}>{proyecto.name}</h3>
        
        <div className={styles.info}>
          <div className={styles.infoItem}>
            <User size={14} className={styles.icon} />
            <span>{userName}</span>
          </div>
          
          <div className={styles.infoItem}>
            <DollarSign size={14} className={styles.icon} />
            <span>
              {proyecto.currency || 'ARS'} {parseFloat(proyecto.budget || '0').toLocaleString()}
            </span>
          </div>
        </div>

        {proyecto.subcategory && (
          <div className={styles.category}>
            {proyecto.category?.name} / {proyecto.subcategory.name}
          </div>
        )}

        <div className={styles.actions}>
          <button
            className={styles.viewButton}
            onClick={() => onViewDetails(proyecto)}
          >
            <Eye size={14} />
            Ver detalles
          </button>

          {(!proyecto.state || proyecto.state === '' || proyecto.state === 'pending') && (
            <div className={styles.validationButtons}>
              <button
                className={styles.approveButton}
                onClick={() => onValidate(proyecto.id, true)}
                disabled={validationLoading}
              >
                <CheckCircle size={18} />
              </button>
              <button
                className={styles.rejectButton}
                onClick={() => onValidate(proyecto.id, false, 'Rechazado desde la tarjeta')}
                disabled={validationLoading}
              >
                <XCircle size={18} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnteProyectoCard;

